import searchUnFilter from '../../../searchUnFilter';

const RAZZLE_APP_ACCOUNTS = process.env.RAZZLE_APP_ACCOUNTS;

const handlePostLoginAndFollowRedirect = (postId, userIdToFollow) => {
    const returnUrl = `/vibe/callback-with-follow?followUserId=${encodeURIComponent(userIdToFollow)}&redirectPostId=${encodeURIComponent(postId)}${searchUnFilter(document.location.search)}`;
    setTimeout(() => {
        window.location.href = RAZZLE_APP_ACCOUNTS
            + '/endpoint?cache=0&new=true&continue='
            + encodeURIComponent(returnUrl);
    }, 500);
};

export default handlePostLoginAndFollowRedirect;

